<template>
    <div id="vehiclemodel_list">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{pageTitle}}</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <button class="btn btn-secondary"  v-if="canGenerateBill && hideButton === false" data-toggle="modal" data-target="#myModal">   Generate Bill</button>
                        <a href="javascript:void(0)" v-if="canExport"  class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <button type="submit" v-if="canAddMod && hideButton === false" class="btn btn-primary" v-on:click.prevent="addFuelTicket" >
                               <i class="fp-add"> </i> Add
                        </button>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="submit" v-if="canAddMod && hideButton === false" class="btn btn-primary" v-on:click.prevent="addFuelTicket" >
                               <i class="fp-add"> </i> Add
                        </button>
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <a href="javascript:void(0)" v-if="canExport" class="" v-on:click="exportCheck()">Export</a> </li>
                                <li><a class=""  v-if="canGenerateBill && hideButton === false" data-toggle="modal" data-target="#myModal">   Generate Bill</a>  </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-detail fuel-ticket-list">
                        <data-table-filter-config :moduleName="'fuelTicketList'" ref="filterFuelTicket" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <p v-if="batchProcess1" id="processFetchBatchMsg" class="alert-success p-2">Current batch {{batchNum1}} is processing. Please wait while we process the unprocessed tickets !!</p>
                          <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'fuelTicketList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="fuelTicketList"
                                      mode="remote"
                                      title="FuelTickets"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: canDeleteMod,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action' ">
                                                  <router-link title="Print Fuel ticket" class="fp-print mr-3" v-bind:to="{name: 'FuelTicketPreview',params:{id:props.row.id}}"></router-link>
                                                  <template v-if="props.row.status != 'Billed'">
                                                      <tepmplate v-if="props.row.status == 'Processed' && userRole == 'fueler'">

                                                      </tepmplate>
                                                      <template v-else>
                                                          <router-link title="Edit Fuel ticket" v-if="canUpdateMod == true && props.row.status.toLowerCase() == 'entered'" class="fp-edit mr-3" v-bind:to="{name: 'FuelTicketEdit',params:{id:props.row.id}}"></router-link>
                                                      </template>
                                                  </template>

                                              </div>
                                              <div v-else-if="props.column.field == 'seq_number'">
                                                  <router-link v-if="canUpdateMod == true"  title="View Fuel Ticket" class="color-blue" v-bind:to="{name: 'FuelTicketView',params:{id:props.row.id}}">{{ props.row.seq_number }}</router-link>
                                              </div>

                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>

                                          </div>
                                      </template>

                                      <template slot="selected-row-actions" v-if="showProcessBtn">
                                          <button v-if="canGenerateBill" id="statusVehicleModelBtn" v-on:click.prevent="changeFuelTicketStatus('process')" class="btn btn-primary mr-2">Process</button>
                                      </template>
                                      <template slot="selected-row-actions" v-if="showUnProcessBtn">
                                          <button v-if="canGenerateBill" id="statusVehicleModelBtn" v-on:click.prevent="changeFuelTicketStatus('unprocess')" class="btn btn-primary mr-2">Unprocess</button>
                                      </template>

                                      <template slot="selected-row-actions"  v-if="showRemoveBtn">
                                          <button v-if="canDeleteMod" id="deleteVehicleModelBtn" v-on:click.prevent="fuelTicketDelete" class="btn btn-danger">Delete</button>
                                      </template>


                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Generate Bill</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form autocomplete="off" id="importFile" class="addinspectionForm basic-form-container pb-0">
                                            <div class="form-row">
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label require" for="cutoff_date">Cutoff Date :</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="cutoff_date" name="cutoff_date" v-model="cutoff_date" :config="optionsDate"></date-picker>
                                                        <label for="cutoff_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <span class="field-error">{{cutoff_date_error_msg}}</span>
                                                </div>
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label require" for="invoice_date">Invoice Date :</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="invoice_date" name="cutoff_date" v-model="invoice_date" :config="optionsDate"></date-picker>
                                                        <label for="invoice_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <span class="field-error">{{invoice_date_error_msg}}</span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button class="btn btn-primary" id="readingButton" v-on:click="generateInvoice()"> OK</button>
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="modal fade entered-ticket-message-modal" id="entered-ticket-message-modal" ref="billedInvoiceMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="billedInvoiceMessageModal" aria-hidden="true">

                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Message</h5>
                                <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                            </div>
                            <div class="modal-body">

                                <div class="col-xs-12 col-md-12 col-md-12 col-lg-12">
                                    <label class="control-label" v-show="statusMessageError">Following fuel tickets status has been changed : </label>
                                    <template v-if="enteredStatusArr.length">
                                        <template v-for="(inv,key) in enteredStatusArr">
                                            <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; , &nbsp;&nbsp;</a><span :key="'j' + key"> {{inv}}</span>
                                        </template>
                                    </template>

                                </div>

                            </div>
                            <div class="modal-footer btm-action-btn-fl">
                                <button type="button" class="btn pull-right cancel-btn" data-dismiss="modal"> <i class="hi-icon icon-flCancel"> </i> Cancel</button>
                            </div>
                        </div>
                    </div>
                </div> -->
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>

</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import moment from 'moment';

import VueSSE from 'vue-sse'
Vue.use(VueSSE);

// import Echo from "laravel-echo";

// window.io = require('socket.io-client');

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
let msgServer
    export default {
        name: "FuelTicketList",
        metaInfo() {
            return {title: "Fuel Ticket List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            pageTitle:"Fuel Ticket List",
            hideButton:false,
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Sequence',
                    field: 'seq_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Ticket Date',
                    field: 'ticket_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false
                },

                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Entered','Processed','Billed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Product',
                    field: 'item',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false
                },
                {
                    label: 'Qty',
                    field: 'quantity',
                    filterable: true,
                    fpFieldType:"integer",
                    type: 'number',
                    hidden:false
                },
                {
                    label: 'Price',
                    field: 'price',
                    filterable: true,
                    fpFieldType:"integer",
                    type: 'number',
                    hidden:false
                },
                {
                    label: 'Billable',
                    field: 'is_billable',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Billable", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Miscellaneous Unit',
                    field: 'referance_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                
                {
                    label: 'Pump',
                    field: 'pump_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
            ],
            rows: [],
            totalRecords: 0,
            canDeleteMod: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            canGenerateBill:false,
            canExport:false,
            action:'list',
            cutoff_date:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            cutoff_date_error_msg:"",
            invoice_date:moment().format("MM/DD/YYYY"),
            invoice_date_error_msg:"",
            batchProcess1:false,
            batchId:0,
            batchNum1:'',
            pageKey:"_fuel_ticket_list_",
            userRole:'',
            showProcessBtn:false,
            showRemoveBtn:false,
            billedSelected:false,
            enteredStatusArr:[],
            statusMessageError:false,
            batchProcess:0,
            batchNum:"",
            batchError:false,
            batchErrorMsg:"",
            showUnProcessBtn:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_ticket') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_fuel_ticket') {
                          if(self.$route.query.flag == 'fuelReport'){
                            self.canDeleteMod = false;
                          } else{
                            self.canDeleteMod = true;
                          }
                        }
                        if (permissions[i].name == 'add_fuel_ticket') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                        }
                        if (permissions[i].name == 'generate_fuel_bill') {
                            self.canGenerateBill = true;
                        }
                        if (permissions[i].name == 'export_fuel_ticket') {
                            self.canExport = true;
                        }
                    }
                }

            }
        },
        created : function () {
            let self = this;

            // if (typeof io !== 'undefined') {
            //     window.Echo = new Echo({
            //         broadcaster: 'socket.io',
            //         host: process.env.REDIS_HOST
            //     });
            // }

        },
        beforeDestroy() {
            // Make sure to close the connection with the events server
            // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
            if(self.$route.query.flag == 'fuelReport'){
              self.hideButton = true;
              self.pageTitle = "Fuel Ticket Detail";
              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }
            self.cutoff_date=moment().format("MM/DD/YYYY");
               var userObj = JSON.parse(localStorage.getItem("user_obj"));

                if (userObj != null) {
                    var dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
                    if (dateTimeFormat != null) {
                        //console.log(dateTimeFormat);
                        //set date time format in optionsDate format of date picker
                    }

                    if (userObj.roles.length > 0) {
                        for(var i = 0; i < userObj.roles.length; i++){
                            if (userObj.roles[i].name == 'fueler') {
                                self.userRole = userObj.roles[i].name;

                            }

                        }
                        // self.userRole = "fueler";
                        // console.log("ROLESS === " , self.userRole);
                        if(self.userRole === "fueler") {

                            var idx = this.columns.findIndex(obj => obj.label == 'Total Cost');
                            if(idx !== -1) {
                              this.columns.splice(idx,1);
                            }
                            var idx = this.columns.findIndex(obj => obj.label == 'Tax');
                            if(idx !== -1) {
                              this.columns.splice(idx,1);
                            }
                            var idx = this.columns.findIndex(obj => obj.label == 'Unit Price');
                            if(idx !== -1) {
                              this.columns.splice(idx,1);
                            }
                            var idx = this.columns.findIndex(obj => obj.label == 'Unit Cost');
                            if(idx !== -1) {
                              this.columns.splice(idx,1);
                            }
                            var idx = this.columns.findIndex(obj => obj.label == 'Total Invoiced');
                            if(idx !== -1) {
                              this.columns.splice(idx,1);
                            }
                        }

                    }

                }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.fuelTicketList.unselectAllInternal();
            },
            addFuelTicket() {
                var self = this;

                if(self.userRole == 'fueler')
                {
                    self.checkFuelReading();

                }else{
                    var self = this;
                    self.$router.push("/fuel-ticket/create");
                }

            },
            checkFuelReading(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-reading/check",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // if(data.status=='location_error')
                        // {
                        //     self.user_location_error="User not mapped with any location please contact admin.";
                        // }
                        if(data.status=='not_found'){
                            // self.$swal('','Fuel Reading is not added. Please first add fuel reading.','info');
                            self.$swal('','Fuel Reading is not added. Please first add fuel reading.','info').then((value) => {
                            self.$router.push("/fuel-reading/create");
                            });
                        }else{
                            self.$router.push("/fuel-ticket/create");
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-ticket-load-by-location')
                    }
                });
            },
            checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess1 = false;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.batchProcess1 = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['fuelTicketList'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;

                var rowData = self.$refs['fuelTicketList'].selectedRows;
                var selectedStatusArr = [];
                console.log(rowData);
                // self.showRemoveBtn = false;
                self.showRemoveBtn = true;
                self.showProcessBtn = false;
                self.showUnProcessBtn = false;
                if(rowData.length > 0){
                    
                    for(var i = 0;i<rowData.length;i++){
                        
                        selectedStatusArr.push(rowData[i].status.toLowerCase());
                        
                        if(rowData[i].status.toLowerCase() == 'entered'){
                            self.showProcessBtn = true;
                        }
                        if(rowData[i].status.toLowerCase() == 'processed'){
                            self.showUnProcessBtn = true;
                        }
                    }

                    //check all values in array are equal or not
                    const allEqual = arr => arr.every( v => v === arr[0] );
                    var billedFound = allEqual(selectedStatusArr);

                    if (billedFound && selectedStatusArr.includes("billed")) {

                        self.showRemoveBtn = false;
                    }else{
                        self.showRemoveBtn = true;

                    }

                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            generateInvoice(){
                var self = this;
                var error = false;
                self.cutoff_date_error_msg='';
                self.invoice_date_error_msg="";
                if (!self.cutoff_date || self.cutoff_date == null || self.cutoff_date == "" ) {
                    self.cutoff_date_error_msg = "Cutoff Date Required.";
                    error = true;
                }
                if (!self.invoice_date || self.invoice_date == null || self.invoice_date == "" ) {
                    self.invoice_date_error_msg = "Date Required.";
                    error = true;
                }
                if (!error) {
                $("#myModal").modal("hide");
                self.loading = true;

                var fields = $('#fuelTicketCreate').serializeArray();
                fields.push({name: "cutoff_date", value: self.cutoff_date});
                fields.push({name: "invoice_date", value: self.invoice_date});

                $.ajax({
                    url: process.env.ROOT_API + "/fuel-ticket/invoice/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            self.cutoff_date="";

//
                            if (data.code == 201){

                                self.batchProcess1 = true;
                                self.batchId = data.batchId;
                                self.checkBatchStatus();

                                setTimeout(function(){
                                    $("#processFetchBatchMsg").text('');
                                    $("#processFetchBatchMsg").text(data.message);
                                },100);
                            }else{

                                self.batchId = data.batchId;
                                self.batchNum1 = data.batchNumber;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
//                                self.loadList();
                            }

                        } else {
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'fuel-ticket-generate-invoice')
                    }
                });
                }
            },
            loadList() {
                var self = this;
                var use = [];
                 if ( self.firstLoad == 1 ) {
                    if(this.$refs['fuelTicketList'].selectedRows.length > 0){
                        var data = this.$refs['fuelTicketList'].selectedRows;

                        for (var i = 0; i < data.length; i++) {
                            use.push(this.$refs['fuelTicketList'].selectedRows[i].id)
                        }
                    }
                 }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use,
                    selectedRows:use,
                };
                // console.log(use);
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-ticket/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filterFuelTicket.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                // self.loadList();

                            } else if ( self.action =='process' ||  self.action =='unprocess' ) { 

                                self.action = 'list';
                                self.$refs.filterFuelTicket.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                            if (data.batchId){
                                self.batchId = data.batchId;
                                self.batchNum1 = data.batch;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
                            }
                        } else{
                            if (data.batchId){
                                self.batchId = data.batchId;
                                self.batchNum1 = data.batch;
                                self.batchProcess1 = true;
                                self.checkBatchStatus();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == 'delete'){
                            self.generateStatusCodeMessage(jqXHR,false,'load-fuel-drop-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'load-fuel-drop-list')
                        }

                    }
                });

                // to set the page content's margin top w.r.t page name's height
                if($(window).width() < 768) {
                    $('.fuel-ticket-list').css('margin-top', ($('.page-name').outerHeight() + 5));
                }else{
                    $('.fuel-ticket-list').removeAttr('style');
                }
                $(window).resize(function(){
                    if($(this).width() < 768) {
                        $('.fuel-ticket-list').css('margin-top', ($('.page-name').outerHeight() + 5));
                    }else{
                        $('.fuel-ticket-list').removeAttr('style');
                    }
                });
            },
            fuelTicketDelete() {
                // var data = this.$refs['fuelTicketList'].selectedRows;
                var self = this;

                var rowData = self.$refs['fuelTicketList'].selectedRows;
                var selectedStatusArr = [];

                if(rowData.length > 0){

                    for(var i = 0;i<rowData.length;i++){
                        selectedStatusArr.push(rowData[i].status.toLowerCase());
                    }

                    if (selectedStatusArr.includes("billed")) {
                        self.$swal('','Please select Ticket Which has status Entered and Processed','info');
                    }else{
                      self.$swal({
                          title: 'Are you sure that you want to delete this Fuel Ticket?',
                          type: 'info',
                          showCancelButton: true,
                          confirmButtonText: 'Yes',
                          cancelButtonText: 'No',
                          showCloseButton: false,
                          showLoaderOnConfirm: true
                      }).then((result) => {
                          if (result.value) {
                                self.action = 'delete';
                                self.loadList();
                          } else {
                            console.log("no");
                          }
                      });
                        // if (confirm('Are you sure that you want to delete this Fuel Ticket?')) {
                        //
                        // }
                    }
                }

            },
            changeFuelTicketStatus(action){
                var self = this;
                self.action = action;
                self.loadList();
            },
            hideMessageModal() {
                var self = this;
                self.statusMessageError = false;
                self.enteredStatusArr = [];
                $("#entered-ticket-message-modal").modal("hide");
            },
        }

    };
    // EventBus.$on('logged-in', function (isLogin,name,role,username,file_path) {

    //   console.log(role);
    //   console.log('name =', name);
    //   console.log('isLogin =', isLogin);
    //   console.log('username =', username);
    //   console.log('file_path =', file_path);

    //     // contex.isShowLoggedinfields = isLogin;
    //     // contex.loggedin_user = name;
    //     // contex.role = role;
    //     // contex.username = username;

    //     // if (file_path != null){
    //     //     contex.image = file_path;
    //     // }else{
    //     //     contex.image = "/static/images/default.jpg";
    //     // }

    // });
</script>



// WEBPACK FOOTER //
// src/components/FuelTicketList.vue